import type { BackendRouteDefinition } from '../types';

/**
 * Migrated to `api-core-node` in PRA-802 (Phase 5 / Sub-phase 8 / S8-WB1).
 * The `loadAndFillTextTemplateSecondGen` callable stays deployed in
 * `cloudFunctions/` until the Sub-phase 9 retirement sweep.
 */
export const loadAndFillTextTemplateRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/templates:fill',
} as const satisfies BackendRouteDefinition;
